import DeferredMedia from "deferred-media";

class LazyVideo extends DeferredMedia {
  connectedCallback() {
    const lazyVideoObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const lazyVideo = entry.target;
        if (!entry.isIntersecting) return;

        if (!lazyVideo.hasAttribute("loaded")) {
          lazyVideo.loadContent();

          const video = lazyVideo.querySelector("video");
          if (!video) return;

          // ✅ ONLY autoplay if muted
          if (video.muted) {
            video.play().catch(() => {});
          }
        }
      });
    });

    lazyVideoObserver.observe(this);
  }
}

customElements.define("lazy-video", LazyVideo);